import React, { useState } from "react";
import { Mail, MapPin, Instagram, Send } from "lucide-react";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { useToast } from "../hooks/use-toast";

export default function Contact() {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast({ title: "Please fill all fields", variant: "destructive" });
      return;
    }
    toast({ title: "Message sent!", description: "Our team will get back to you within 24 hours." });
    setForm({ name: "", email: "", message: "" });
  };

  const cards = [
    { icon: Mail, title: "Email", value: "flychertravels@gmail.com", href: "mailto:flychertravels@gmail.com" },
    { icon: Instagram, title: "Instagram", value: "@flychertravels", href: "https://instagram.com/flychertravels" },
    { icon: MapPin, title: "Visit", value: "New Delhi, India" },
  ];

  return (
    <div className="bg-white min-h-screen">
      <section className="hero-dark pt-28 pb-14">
        <div className="max-w-7xl mx-auto px-5">
          <h1 className="text-4xl md:text-5xl font-bold text-white">Get in touch</h1>
          <p className="mt-3 text-slate-300 max-w-xl">Tell us where you want to go, and we’ll sort out everything else.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 py-12 grid gap-10 lg:grid-cols-2">
        <div className="space-y-4">
          {cards.map((c) => {
            const inner = (
              <>
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-coral-600 text-white"><c.icon className="w-5 h-5" /></span>
                <div><p className="text-sm text-slate-500">{c.title}</p><p className="font-semibold text-slate-900">{c.value}</p></div>
              </>
            );
            return c.href ? (
              <a key={c.title} href={c.href} target={c.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer"
                className="flex items-center gap-4 bg-slate-50 hover:bg-slate-100 rounded-2xl p-5 transition-colors">
                {inner}
              </a>
            ) : (
              <div key={c.title} className="flex items-center gap-4 bg-slate-50 rounded-2xl p-5">
                {inner}
              </div>
            );
          })}
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 space-y-4">
          <div><Label>Name</Label><Input value={form.name} onChange={set("name")} className="mt-1" placeholder="Your name" /></div>
          <div><Label>Email</Label><Input value={form.email} onChange={set("email")} type="email" className="mt-1" placeholder="you@email.com" /></div>
          <div><Label>Message</Label><Textarea value={form.message} onChange={set("message")} className="mt-1" rows={5} placeholder="How can we help?" /></div>
          <Button type="submit" className="w-full h-11 bg-coral-600 hover:bg-coral-700 text-white"><Send className="w-4 h-4 mr-2" /> Send Message</Button>
        </form>
      </section>
      <Footer />
    </div>
  );
}
